import { withI18n } from 'react-i18next';
import AddressDescription from './AddressDescription';

export const pureComponent = AddressDescription;
export default withI18n()(AddressDescription);
